import { TableProps as AntdTableProps } from 'antd/lib/table';

export type TableProps = AntdTableProps & {};

type DefaultTableProps = {};

export const defaultProps: DefaultTableProps = {};